import { createRouter, createWebHistory  } from 'vue-router'
import HomeMain from "../views/HomeMain.vue";
import EventView from "../views/EventView.vue";
import HostEventView from "../views/HostEventView.vue";
import ConfirmationView from "../views/ConfirmationView.vue";
import PendingView from "../views/PendingView.vue";
import InvitationView from "../views/InvitationView.vue";
import UserTicketView from "../views/UserTicketView.vue";
import PdfGenerationTest from "../components/sales/PdfGenerationTest.vue";
import EventHostView from  "../pages/host/EventHostView.vue";
import EventOperatorView from  "../pages/operator/EventOperatorView.vue";
import TermsView from "../views/TermsView.vue";
import PrivacyView from "../views/HomeView.vue";
import RefundsView from "../views/AboutView.vue";
import ContactView from "../components/HelloWorld.vue";
import CompanyView from "../components/HelloWorld copy.vue";
import LaunchEventView from "../views/LaunchEventView.vue";
import PreloaderComponent from "../components/PreloaderComponent.vue";
import ProccessPayment from "../components/sales/ProccessPayment.vue";

import ZocialView from "../views/reservations/ZocialView.vue";
import LaUltimaView from "../views/reservations/LaUltimaView.vue";



import AdminView from  "../pages/admin/AdminView.vue";
import { CSRF_TOKEN } from "../common/csrf_token.js";





//import PaginaDetalle from "../views/PaginaDetalle.vue"
//import Profile from "../views/Profile.vue"
//import ViewPaginaDetalle from "../views/ViewPaginaDetalle.vue"
//import NextReleases from "../views/NextReleases.vue"
//import Preloader from "../views/Preloader.vue"

function guardMyroute(to, from, next)
{
 var isAuthenticated= false;
//this is just an example. You will have to find a better or 
// centralised way to handle you localstorage data handling 

 if (localStorage.getItem('is_allowed')==true  || localStorage.getItem('is_allowed')=="true" || hasAdminCenterAccess()){

  isAuthenticated = true;
}
else
  isAuthenticated= false;
 if(isAuthenticated) 
 {
  next(); // allow to enter route
 } 
 else
  {

  next({ name: 'preloader', query: { next: to.fullPath } });
  }
}


function hasAdminCenterAccess()
{
  return localStorage.getItem('is_admin')==true
    || localStorage.getItem('is_admin')=="true"
    || localStorage.getItem('is_superuser')==true
    || localStorage.getItem('is_superuser')=="true"
}




function operatorGuard(to, from, next)
{
 const isAuthenticated = localStorage.getItem('is_operator') == true || localStorage.getItem('is_operator') == "true"

 if (isAuthenticated) {
  next();
 } else {
  console.log("valido")
  next('/preloader');
 }
}

function cashierGuard(to, from, next) {
  if (localStorage.getItem('organizer_access_token')) next()
  else next({ name: 'preloader', query: { next: to.fullPath } })
}




function AdminGuard(to, from, next)
{
 const isAdmin = hasAdminCenterAccess()
 if (isAdmin) {
  next();
 } else {
  console.log("valido")
  next({ name: 'admin-login', query: { next: to.fullPath } });
 }
}

function eventSlugGuard(to, from, next)
{
  if (!to.params.slug) {
    next({ name: 'home' });
    return;
  }

  next();
}


function ambassadorGuard(to, from, next)
{
 const isAuthenticated = localStorage.getItem('is_ambassador_allowed') == true || localStorage.getItem('is_ambassador_allowed') == "true"
 if (isAuthenticated) {
  next();
 } else {
  next({ name: 'ambassador-access', query: { next: to.fullPath } });
 }
}





function logOutRoute(to, from, next)
{
  window.localStorage.removeItem('id');
  window.localStorage.removeItem('is_admin');
  window.localStorage.removeItem('is_staff');
  window.localStorage.removeItem('is_superuser');
  window.localStorage.removeItem('username');
  window.localStorage.removeItem('is_allowed');
  window.localStorage.removeItem('is_lail');
  window.localStorage.removeItem('is_student');
  window.localStorage.removeItem('is_active_student');
  window.localStorage.removeItem('is_special_case');
  window.localStorage.removeItem('is_active_company');
  window.localStorage.removeItem('organizer_access_token');
  window.localStorage.removeItem('organizer_refresh_token');
  window.localStorage.removeItem('organizer_access_email');
  window.localStorage.removeItem('ticket_access_token');
  window.localStorage.removeItem('ticket_access_refresh_token');
  window.localStorage.removeItem('ticket_refresh_token');
  window.localStorage.removeItem('ticket_access_email');
  window.localStorage.removeItem('ticket_access_user_id');
  window.localStorage.removeItem('ambassador_access_token');
  window.localStorage.removeItem('ambassador_refresh_token');
  window.localStorage.removeItem('ambassador_email');
  window.localStorage.removeItem('ambassador_name');
  window.localStorage.removeItem('is_ambassador_allowed');

  fetch('/api/admin/logout/', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'X-CSRFTOKEN': CSRF_TOKEN,
    },
  }).finally(() => {
    next()
  })

}

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeMain
  },
  
  {
    path: "/event/:slug?/",
    name: "event",
    component: EventView,
    beforeEnter: eventSlugGuard,
    props:true,
    query: {
      co: 'co'
    }

  },


  {
    path: "/reservations/zocial/",
    name: "reservations",
    component: ZocialView,
    props:true,
    query: {
      co: 'co'
    }

  },


  {
    path: "/reservations/la-ultima/",
    name: "reservations2",
    component: LaUltimaView,
    props:true,
    query: {
      co: 'co'
    }

  },




  {
    path: "/event/loading/",
    name: "loading",
    component: PreloaderComponent,
    props:true,
    query: {
      co: 'co'
    }

  },


  {
    path: "/host/:host?/",
    name: "host",
    component: HostEventView,
    props:true,
    query: {
      co: 'co'
    }

  },



  
  {
    path: "/success/",
    name: "success",
    component: ProccessPayment,
    props:true,
    query: {
      co: 'co'
    }

  },



  {
    path: "/order-confirmation/:id?",
    name: "confirmation",
    component: ConfirmationView,
    props:true,
    query: {
      co: 'co'
    }

  },


  {
    path: "/pdf-confirmation/",
    name: "test-pdf",
    component: PdfGenerationTest,
    props:true,
    query: {
      co: 'co'
    }

  },



  {
    path: "/user-tickets/",
    name: "usertickets",
    component: UserTicketView,
    props:true,
    query: {
      co: 'co'
    }

  },


  {
    path: "/order-pending-confirmation/:id?",
    name: "pending-confirmation",
    component: PendingView,
    props:true,
    query: {
      co: 'co'
    }

  },



  {
    path: "/terms/",
    name: "terms",
    component: TermsView,
    

  },

  {
    path: "/privacy/",
    name: "privacy",
    component: PrivacyView,
  },

  {
    path: "/refunds/",
    name: "refunds",
    component: RefundsView,
  },

  {
    path: "/contact/",
    name: "contact",
    component: ContactView,
  },

  {
    path: "/company/",
    alias: ["/about/"],
    name: "company",
    component: CompanyView,
  },

  {
    path: '/lanza-tu-evento',
    name: 'launch-event',
    component: LaunchEventView,
  },

  



  

  {
    name: 'wallet',
    path: '/wallet',
    alias: ['/account'],
    component: () => import('../pages/user/ListAccountView.vue'),
    props: true,

  },




  {
    path: "/experience/:id?",
    name: "experience",
    component: InvitationView,
    props:true,
    query: {
      co: 'co'
    }

  },


  {
    name: 'events',
    path: '/events-legacy',
    component: () => import('../pages/host/ListEventView.vue'),
    props: true,
    beforeEnter : guardMyroute,

  },

  {
    name: 'events2',
    path: '/events',
    alias: ['/events2'],
    component: () => import('../pages/host/ListEventView2.vue'),
    props: true,
    beforeEnter : guardMyroute,

  },

  {
    name: 'swap-seller',
    path: '/swap/seller',
    redirect: { name: 'usertickets', query: { tab: 'sell', sellSection: 'sell' } },
  },

  {
    name: 'go-credits',
    path: '/go-credits',
    component: () => import('../pages/host/GoCreditsView.vue'),
    beforeEnter: guardMyroute,
  },

  {
    name: 'swap-seller-legacy',
    path: '/seller/swap',
    redirect: { name: 'usertickets', query: { tab: 'sell', sellSection: 'sell' } },
  },

  {
    name: 'swap-seller-sell',
    path: '/swap/seller/sell',
    redirect: { name: 'usertickets', query: { tab: 'sell', sellSection: 'sell' } },
  },

  {
    name: 'swap-seller-tickets',
    path: '/swap/seller/tickets',
    redirect: { name: 'usertickets', query: { tab: 'sell', sellSection: 'tickets' } },
  },

  {
    name: 'swap-seller-deliveries',
    path: '/swap/seller/deliveries',
    redirect: { name: 'usertickets', query: { tab: 'sell', sellSection: 'tickets' } },
  },

  {
    name: 'swap-seller-messages',
    path: '/swap/seller/messages',
    redirect: { name: 'usertickets', query: { tab: 'sell', sellSection: 'tickets' } },
  },

  {
    name: 'swap-seller-finance',
    path: '/swap/seller/finance',
    redirect: { name: 'usertickets', query: { tab: 'sell', sellSection: 'finance' } },
  },

  {
    name: 'swap-seller-profile',
    path: '/swap/seller/profile',
    redirect: { name: 'usertickets', query: { tab: 'sell', sellSection: 'profile' } },
  },

  {
    name: 'ambassador-access',
    path: '/pr-access',
    component: () => import('../pages/ambassadors/AmbassadorAccessView.vue'),
    props: true,
  },

  {
    name: 'prevents',
    path: '/pr-events',
    component: () => import('../pages/ambassadors/PrListEventView.vue'),
    props: true,
    beforeEnter : ambassadorGuard,

  },

  {
    name: 'ambassador-event',
    path: '/pr-events/:eventId',
    component: () => import('../pages/ambassadors/AmbassadorEventView.vue'),
    props: true,
    beforeEnter : ambassadorGuard,

  },

  {
    path: "/event-host-legacy/:slug?",
    name: "EventHostView",
    component: EventHostView,
    beforeEnter : guardMyroute,
    props:true,
    query: {
      co: 'co'
    }

  },

  {
    path: "/event-host/:slug?",
    alias: ["/event-host2/:slug?"],
    name: "EventHostView2",
    component: () => import('../pages/host/EventHostView2.vue'),
    beforeEnter : guardMyroute,
    props:true,
    query: {
      co: 'co'
    }

  },


  {
    name: 'event-creation',
    path: '/events/new',
    alias: ['/event/create'],
    component: () => import('../pages/host/EventCreationView.vue'),
  },

  {
    name: 'promo',
    path: '/promo',
    component: () => import('../pages/host/Promotion.vue'),
    beforeEnter : guardMyroute,
  },

  {
    name: 'tools2',
    path: '/tools2',
    component: () => import('../pages/host/ToolsView2.vue'),
    beforeEnter : guardMyroute,
  },

  {
    name: 'tools-venue-studio',
    path: '/tools2/venues/:layoutId/studio',
    component: () => import('../pages/host/VenueStudioStandaloneView.vue'),
    props: (route) => ({
      layoutId: route.params.layoutId,
      eventId: route.query.eventId,
      eventSlug: route.query.eventSlug,
    }),
    beforeEnter : guardMyroute,
  },

  {
    name: 'finances',
    path: '/finances',
    component: () => import('../pages/host/Finance.vue'),
    beforeEnter : guardMyroute,
  },

  {
    name: 'finances2',
    path: '/finances2',
    component: () => import('../pages/host/FinanceView2.vue'),
    beforeEnter : guardMyroute,
  },






  {
    name: 'qr-test',
    path: '/qr-test',
    component: () => import('../pages/operator/QrTest.vue'),
    beforeEnter : guardMyroute,
  },


  {
    name: 'cashier',
    path: '/cashier/:registerId?',
    component: () => import('../pages/cashier/CashierView.vue'),
    beforeEnter: cashierGuard,
  },
  {
    name: 'qr-reader',
    path: '/qr-reader',
    redirect: { name: 'operator-events' },
    beforeEnter : operatorGuard,
  },

  {
    name: 'operator-events',
    path: '/operator-events',
    component: () => import('../pages/operator/ListEventView.vue'),
    props: true,
    beforeEnter : operatorGuard,

  },

  {
    path: "/event-operator/:slug?",
    name: "EventOperatorView",
    component: EventOperatorView,
    beforeEnter : operatorGuard,
    props:true,
    query: {
      co: 'co'
    }

  },









  {
    name: 'preloader',
    path: '/preloader',
    alias: ['/access', '/preloader2'],
    props: true,
    component: () => import('../views/Preloader2View.vue'),
  },
  
  {
  name: 'LogOut',
  path: '/logout',
  props: true,
  beforeEnter : logOutRoute,
  component: () => import('../views/SystemLogout.vue'),
},


{
  name: 'venue-test',
  path: '/venue-test',
  component: () => import('../components/sales/VenueMap.vue'),
},



{
  name: 'admin-login',
  path: '/admins/login',
  component: () => import('../views/AdminLoginView.vue'),
  props: true,
},

{
  path: "/admins/",
  name: "AdminView",
  component: AdminView,
  beforeEnter : AdminGuard,
  props:true,
 

},



  
]





const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }else if(to.hash) {
        // BEFORE:
        // return { selector: to.hash }
        return { el: to.hash }
      }else {
      return { top: 0 }
    }
  },
  history: createWebHistory(),
  routes
})

export default router




